/* =========================================================
   PH HOME ENGINE v1.1
   Carruseles + pestañas Top 5
   Flechas reparadas para escritorio y móvil
   ========================================================= */

(() => {
  "use strict";

  const CAROUSEL_SELECTOR = "[data-ph-carousel]";
  const TABS_SELECTOR = "[data-ph-top5]";

  const READY_CAROUSEL =
    "data-ph-carousel-ready";

  const READY_TABS =
    "data-ph-top5-ready";

  const CONTROLS_DELAY = 2500;

  const clamp = (value, min, max) =>
    Math.min(
      Math.max(value, min),
      max
    );

  class Carousel {

    constructor(root) {

      this.root = root;

      this.track =
        root.querySelector(
          "[data-ph-carousel-track]"
        );

      this.prevButton =
        root.querySelector(
          "[data-ph-carousel-prev]"
        );

      this.nextButton =
        root.querySelector(
          "[data-ph-carousel-next]"
        );

      this.hideTimer = null;

      if (!this.track) {
        return;
      }

      this.handlePreviousClick =
        this.handlePreviousClick.bind(this);

      this.handleNextClick =
        this.handleNextClick.bind(this);

      this.handleScroll =
        this.handleScroll.bind(this);

      this.handleResize =
        this.handleResize.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.showControls =
        this.showControls.bind(this);

      this.scheduleHide =
        this.scheduleHide.bind(this);

      this.init();
    }

    init() {

      if (
        this.root.getAttribute(
          READY_CAROUSEL
        ) === "true"
      ) {
        return;
      }

      this.root.setAttribute(
        READY_CAROUSEL,
        "true"
      );

      this.root.phCarousel = this;

      this.prevButton?.addEventListener(
        "click",
        this.handlePreviousClick
      );

      this.nextButton?.addEventListener(
        "click",
        this.handleNextClick
      );

      this.track.addEventListener(
        "scroll",
        this.handleScroll,
        {
          passive: true
        }
      );

      this.track.addEventListener(
        "pointerdown",
        this.showControls,
        {
          passive: true
        }
      );

      this.root.addEventListener(
        "mouseenter",
        this.showControls
      );

      this.root.addEventListener(
        "mouseleave",
        this.scheduleHide
      );

      this.root.addEventListener(
        "focusin",
        this.showControls
      );

      this.root.addEventListener(
        "focusout",
        this.scheduleHide
      );

      this.root.addEventListener(
        "keydown",
        this.handleKeydown
      );

      window.addEventListener(
        "resize",
        this.handleResize,
        {
          passive: true
        }
      );

      requestAnimationFrame(() => {
        this.updateControls();
      });

    }

    getSlides() {

      return Array.from(
        this.track.querySelectorAll(
          ".ph-carousel__slide, .ph-carousel__item"
        )
      );

    }

    getStep() {

      const slide =
        this.getSlides()[0];

      if (!slide) {
        return this.track.clientWidth;
      }

      const styles =
        window.getComputedStyle(
          this.track
        );

      const gap =
        Number.parseFloat(
          styles.columnGap ||
          styles.gap ||
          "0"
        ) || 0;

      return (
        slide.getBoundingClientRect().width +
        gap
      );

    }

    getMaximumScroll() {

      return Math.max(
        0,
        this.track.scrollWidth -
        this.track.clientWidth
      );

    }

    move(direction) {

      const maximum =
        this.getMaximumScroll();

      if (maximum <= 4) {

        this.updateControls();
        return;

      }

      const current =
        this.track.scrollLeft;

      const step =
        this.getStep();

      const target =
        clamp(
          current +
          (step * direction),
          0,
          maximum
        );

      if (
        typeof this.track.scrollTo ===
        "function"
      ) {

        this.track.scrollTo({
          left: target,
          behavior: "smooth"
        });

      } else {

        this.track.scrollLeft =
          target;

      }

      this.showControls();

      window.setTimeout(() => {

        this.updateControls();

      }, 450);

    }
        scrollToIndex(
      index,
      behavior = "smooth"
    ) {

      const safeIndex =
        Math.max(
          0,
          Number(index) || 0
        );

      const target =
        clamp(
          this.getStep() * safeIndex,
          0,
          this.getMaximumScroll()
        );

      this.track.scrollTo({
        left: target,
        behavior
      });

      this.showControls();

    }

    handlePreviousClick(event) {

      event.preventDefault();
      event.stopPropagation();

      this.move(-1);

    }

    handleNextClick(event) {

      event.preventDefault();
      event.stopPropagation();

      this.move(1);

    }

    handleScroll() {

      this.updateControls();
      this.showControls();

    }

    handleResize() {

      this.updateControls();

    }

    handleKeydown(event) {

      if (
        event.key === "ArrowLeft"
      ) {

        event.preventDefault();
        this.move(-1);

      }

      if (
        event.key === "ArrowRight"
      ) {

        event.preventDefault();
        this.move(1);

      }

    }

    showControls() {

      window.clearTimeout(
        this.hideTimer
      );

      this.root.classList.add(
        "ph-carousel-active"
      );

      this.hideTimer =
        window.setTimeout(() => {

          this.hideControls();

        }, CONTROLS_DELAY);

    }

    scheduleHide() {

      window.clearTimeout(
        this.hideTimer
      );

      this.hideTimer =
        window.setTimeout(() => {

          this.hideControls();

        }, 350);

    }

    hideControls() {

      const activeElement =
        document.activeElement;

      const arrowHasFocus =

        activeElement &&

        this.root.contains(
          activeElement
        ) &&

        activeElement.matches(
          "[data-ph-carousel-prev], [data-ph-carousel-next]"
        );

      if (!arrowHasFocus) {

        this.root.classList.remove(
          "ph-carousel-active"
        );

      }

    }

    updateControls() {

      const tolerance = 4;

      const maximum =
        this.getMaximumScroll();

      const current =
        clamp(

          Math.max(
            0,
            this.track.scrollLeft
          ),

          0,

          maximum

        );

      const scrollable =
        maximum > tolerance;

      const atStart =
        current <= tolerance;

      const atEnd =
        current >=
        maximum - tolerance;

      this.setButtonState(
        this.prevButton,
        !scrollable || atStart
      );

      this.setButtonState(
        this.nextButton,
        !scrollable || atEnd
      );

      this.root.classList.toggle(
        "ph-carousel--at-start",
        atStart
      );

      this.root.classList.toggle(
        "ph-carousel--at-end",
        atEnd
      );

      this.root.classList.toggle(
        "ph-carousel--scrollable",
        scrollable
      );

    }

    setButtonState(
      button,
      disabled
    ) {

      if (!button) {
        return;
      }

      button.disabled =
        disabled;

      button.tabIndex =
        disabled
          ? -1
          : 0;

      button.setAttribute(
        "aria-hidden",
        String(disabled)
      );

    }
        destroy() {

      window.clearTimeout(
        this.hideTimer
      );

      this.prevButton?.removeEventListener(
        "click",
        this.handlePreviousClick
      );

      this.nextButton?.removeEventListener(
        "click",
        this.handleNextClick
      );

      this.track.removeEventListener(
        "scroll",
        this.handleScroll
      );

      this.track.removeEventListener(
        "pointerdown",
        this.showControls
      );

      this.root.removeEventListener(
        "mouseenter",
        this.showControls
      );

      this.root.removeEventListener(
        "mouseleave",
        this.scheduleHide
      );

      this.root.removeEventListener(
        "focusin",
        this.showControls
      );

      this.root.removeEventListener(
        "focusout",
        this.scheduleHide
      );

      this.root.removeEventListener(
        "keydown",
        this.handleKeydown
      );

      window.removeEventListener(
        "resize",
        this.handleResize
      );

      this.root.removeAttribute(
        READY_CAROUSEL
      );

      this.root.classList.remove(
        "ph-carousel-active"
      );

      delete this.root.phCarousel;

    }

  }

  class Tabs {

    constructor(root) {

      this.root = root;

      this.tabs = Array.from(
        root.querySelectorAll(
          "[data-ph-top5-tab]"
        )
      );

      this.panels = Array.from(
        root.querySelectorAll(
          "[data-ph-top5-panel]"
        )
      );

      this.handleClick =
        this.handleClick.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      if (
        !this.tabs.length ||
        !this.panels.length
      ) {
        return;
      }

      this.init();

    }

    init() {

      if (
        this.root.getAttribute(
          READY_TABS
        ) === "true"
      ) {
        return;
      }

      this.root.setAttribute(
        READY_TABS,
        "true"
      );

      this.root.phTabs = this;

      this.tabs.forEach((tab) => {

        tab.addEventListener(
          "click",
          this.handleClick
        );

        tab.addEventListener(
          "keydown",
          this.handleKeydown
        );

      });

    }

    handleClick(event) {

      this.activate(
        event.currentTarget
          .dataset
          .phTop5Tab
      );

    }

    handleKeydown(event) {

      const keys = [
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End"
      ];

      if (
        !keys.includes(event.key)
      ) {
        return;
      }

      event.preventDefault();

      const currentIndex =
        this.tabs.indexOf(
          event.currentTarget
        );

      let nextIndex =
        currentIndex;

      if (
        event.key === "ArrowLeft"
      ) {

        nextIndex =
          currentIndex === 0
            ? this.tabs.length - 1
            : currentIndex - 1;

      }

      if (
        event.key === "ArrowRight"
      ) {

        nextIndex =
          currentIndex ===
          this.tabs.length - 1
            ? 0
            : currentIndex + 1;

      }

      if (
        event.key === "Home"
      ) {

        nextIndex = 0;

      }

      if (
        event.key === "End"
      ) {

        nextIndex =
          this.tabs.length - 1;

      }

      this.tabs[nextIndex]
        .focus();

      this.activate(
        this.tabs[nextIndex]
          .dataset
          .phTop5Tab
      );

    }
        activate(key) {

      this.tabs.forEach((tab) => {

        const active =
          tab.dataset.phTop5Tab === key;

        tab.classList.toggle(
          "is-active",
          active
        );

        tab.setAttribute(
          "aria-selected",
          String(active)
        );

        tab.tabIndex =
          active
            ? 0
            : -1;

      });

      this.panels.forEach((panel) => {

        const active =
          panel.dataset.phTop5Panel === key;

        panel.hidden =
          !active;

        panel.classList.toggle(
          "is-active",
          active
        );

        if (active) {

          const carousel =
            panel.querySelector(
              CAROUSEL_SELECTOR
            );

          requestAnimationFrame(() => {

            carousel
              ?.phCarousel
              ?.scrollToIndex(
                0,
                "auto"
              );

            carousel
              ?.phCarousel
              ?.updateControls();

          });

        }

      });

    }

    destroy() {

      this.tabs.forEach((tab) => {

        tab.removeEventListener(
          "click",
          this.handleClick
        );

        tab.removeEventListener(
          "keydown",
          this.handleKeydown
        );

      });

      this.root.removeAttribute(
        READY_TABS
      );

      delete this.root.phTabs;

    }

  }

  const collectRoots = (
    container,
    selector
  ) => {

    const roots = [];

    if (
      container instanceof Element &&
      container.matches(selector)
    ) {

      roots.push(container);

    }

    roots.push(
      ...container.querySelectorAll(
        selector
      )
    );

    return roots;

  };

  const initialize = (
    container = document
  ) => {

    collectRoots(
      container,
      CAROUSEL_SELECTOR
    ).forEach((root) => {

      if (
        root.getAttribute(
          READY_CAROUSEL
        ) !== "true"
      ) {

        new Carousel(root);

      }

    });

    collectRoots(
      container,
      TABS_SELECTOR
    ).forEach((root) => {

      if (
        root.getAttribute(
          READY_TABS
        ) !== "true"
      ) {

        new Tabs(root);

      }

    });

  };
    const destroy = (
    container = document
  ) => {

    collectRoots(
      container,
      CAROUSEL_SELECTOR
    ).forEach((root) => {

      root
        .phCarousel
        ?.destroy();

    });

    collectRoots(
      container,
      TABS_SELECTOR
    ).forEach((root) => {

      root
        .phTabs
        ?.destroy();

    });

  };

  const start = () => {

    initialize(document);

  };

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );

  } else {

    start();

  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {

      initialize(
        event.target
      );

    }
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {

      destroy(
        event.target
      );

    }
  );

  window.PH =
    window.PH || {};

  window.PH.Home = {
    Carousel,
    Tabs,
    initialize,
    destroy
  };

})();
/* =========================================================
   PH HOME · MENÚ PRINCIPAL CON PESTAÑAS
   ========================================================= */

(() => {
  const SELECTOR = '[data-ph-favorites-tabs]';

  class PHFavoritesTabs {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(
        section.querySelectorAll('[data-ph-favorites-tab]')
      );
      this.panels = Array.from(
        section.querySelectorAll('[data-ph-favorites-panel]')
      );
      this.indicator = section.querySelector('[data-ph-tab-indicator]');
      this.scrollContainer = section.querySelector('[data-ph-tabs-scroll]');

      if (!this.tabs.length || !this.panels.length) return;

      this.bindEvents();

      requestAnimationFrame(() => {
        this.updateIndicator(this.getActiveTab(), false);
      });
    }

    getActiveTab() {
      return (
        this.tabs.find((tab) => tab.classList.contains('is-active')) ||
        this.tabs[0]
      );
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.activate(tab);
        });

        tab.addEventListener('keydown', (event) => {
          this.handleKeyboard(event, index);
        });
      });

      window.addEventListener(
        'resize',
        this.debounce(() => {
          this.updateIndicator(this.getActiveTab(), false);
        }, 120)
      );

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target === this.section) {
          this.updateIndicator(this.getActiveTab(), false);
        }
      });
    }

    activate(selectedTab) {
      const targetName = selectedTab.dataset.phFavoritesTab;

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;

        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', String(isSelected));
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isSelected =
          panel.dataset.phFavoritesPanel === targetName;

        panel.classList.toggle('is-active', isSelected);

        if (isSelected) {
          panel.removeAttribute('aria-hidden');
        } else {
          panel.setAttribute('aria-hidden', 'true');
        }
      });

      this.updateIndicator(selectedTab, true);
      this.keepTabVisible(selectedTab);

      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }

    updateIndicator(tab, animate = true) {
      if (!tab || !this.indicator) return;

      if (!animate) {
        this.indicator.style.transition = 'none';
      }

      const tabsRect = tab.parentElement.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();

      /*
       * La línea mide aproximadamente el 62% del texto,
       * no el ancho completo de la pestaña.
       */
      const indicatorWidth = Math.max(tabRect.width * 0.46, 4);
      const left =
        tabRect.left -
        tabsRect.left +
        (tabRect.width - indicatorWidth) / 2;

      this.indicator.style.width = `${indicatorWidth}px`;
      this.indicator.style.transform = `translateX(${left}px)`;

      if (!animate) {
        requestAnimationFrame(() => {
          this.indicator.style.removeProperty('transition');
        });
      }
    }

    keepTabVisible(tab) {
      if (!this.scrollContainer) return;

      tab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    handleKeyboard(event, currentIndex) {
      const allowedKeys = [
        'ArrowLeft',
        'ArrowRight',
        'Home',
        'End'
      ];

      if (!allowedKeys.includes(event.key)) return;

      event.preventDefault();

      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      }

      if (event.key === 'ArrowLeft') {
        nextIndex =
          (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      }

      if (event.key === 'Home') {
        nextIndex = 0;
      }

      if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      const nextTab = this.tabs[nextIndex];

      nextTab.focus();
      this.activate(nextTab);
    }

    debounce(callback, delay) {
      let timer;

      return (...args) => {
        window.clearTimeout(timer);

        timer = window.setTimeout(() => {
          callback(...args);
        }, delay);
      };
    }
  }

  const initialize = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((section) => {
      if (section.dataset.phFavoritesTabsReady === 'true') return;

      section.dataset.phFavoritesTabsReady = 'true';
      new PHFavoritesTabs(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();